import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IsAdminService } from '../../../services/admin/is-admin.service';

@Injectable({
  providedIn: 'root',
})
export class ChangeRequestApiService {
  get baseUrl() {
    if (this.isAdminService.isAdmin) {
      return `/apt-admin/api/changerequests`;
    }

    return `/aptitude/api/changerequests`;
  }

  constructor(
    private http: HttpClient,
    private isAdminService: IsAdminService,
  ) {}

  /** @RETURN empty response */
  updateChangeRequest(uploadRequestId: string): Observable<any> {
    return this.http.post(
      this.baseUrl,
      {
        uploadRequestId,
      },
      { observe: 'response' },
    ) as Observable<any>;
  }
}
